import React, { useRef, useContext, useEffect } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import lozad from 'lozad';

import { DispatchContext } from '@store/store';
import { openAuthModal } from '@store/actions';

function TemplateCard(props) {
  const { template } = props;
  const vidRef = useRef();
  const dispatch = useContext(DispatchContext);

  const handleOnClickTemplate = () => {
    const link = `https://invideo.io/workflow/marketing-templates/${
      template.id
    }?dimension=${template.dimension || '16:9'}`;
    if (localStorage.getItem(window.btoa('user'))) {
      window.location.href = link;
    } else {
      dispatch(openAuthModal({ tab: 'signup' }));
    }
  };

  useEffect(() => {
    if (vidRef.current) {
      const VidEl = lozad(vidRef.current);

      VidEl.observe();
    }
  }, []);

  const loadVideo = () => {
    vidRef.current.load();
  };

  const playVideo = () => {
    vidRef.current.play();
  };

  return (
    <VideoTemplateContainer onClick={handleOnClickTemplate}>
      <div className="video-container">
        <video
          onMouseEnter={playVideo}
          onMouseLeave={loadVideo}
          ref={vidRef}
          data-poster={template?.preview_list?.story?.default?.thumbnail_url}
          canplay="yes"
          preload="none"
          muted
        >
          <source
            src={template?.preview_list?.story?.default?.preview_url}
            type="video/mp4"
          />
        </video>
      </div>
      <div className="template-footer">
        <div className="template-name w-full px-1 flex justify-between items-center">
          <span className="truncate">{template.name}</span>
          {template.price && parseInt(template.price, 10) > 0 ? (
            <span className="template-price">${template.price}</span>
          ) : null}
        </div>
      </div>
    </VideoTemplateContainer>
  );
}

TemplateCard.propTypes = {
  template: PropTypes.object,
};

TemplateCard.defaultProps = {
  template: {},
};

export default TemplateCard;

const VideoTemplateContainer = styled.div`
  width: 100%;
  border-radius: 6px;
  background-color: #050e18;
  cursor: pointer;
  margin-bottom: 20px;

  .video-container {
    position: relative;
    width: 100%;
    background-size: cover;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;

    video {
      width: 100%;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }
  }

  .template-footer {
    position: relative;
    width: 100%;
    min-height: 50px;
    display: flex;
    align-items: center;
    padding: 0 10px;

    .template-name {
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.5px;
      text-align: left;
      pointer-events: none;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .template-price {
      color: #9c3;
      font-size: 20px;
      letter-spacing: 0.73px;
    }
  }

  .template-name {
    width: 100%;
  }

  .creator-profile-card > .profile-details > span {
    opacity: 1;
  }
`;
